import React, { useMemo } from "react";
import { TravelType } from "src/store/graphql/helpers/types.graphql";
import { ProgressBar, Step } from "react-step-progress-bar";
import { intervalToDuration } from "date-fns";
import utils from "@helpers/utils";
import {
  TravelStatusInTransit,
  TravelStatusInConstruction,
  TravelStatusDischarging,
  GpsSignal
} from "@assets/icons/index";

import { ReactSVG } from "react-svg";
import useTranslation from "@languages/useTranslation";
import { BaseCardMessages } from "src/languages/interfaces";
import Styled from "./styles";

interface TravelTimelineProps {
    travel: TravelType;
}

const TravelTimeline: React.FC<TravelTimelineProps> = ({ travel }) => {
  const { t, i18n } = useTranslation();

  const travelPercentage = useMemo(() => {
    if (travel.status === "IN_CONSTRUCTION") {
      return 50;
    }
    if (travel.status === "DISCHARGING" || travel.status === "DELIVERED") {
      return 100;
    }

    return 0;
  }, [travel.status]);

  return (
    <Styled.TimelineContainer>
      <div className="timeline__row">
        <div
          className={`time-line__block ${
            travelPercentage >= 100
              ? "discharge"
              : travelPercentage >= 50
                ? "construction"
                : ""
          }`}
        >
          <ProgressBar percent={travelPercentage}>
            <Step transition="scale">
              {({ accomplished }) => (
                <div
                  className={`time-line__step ${
                    !accomplished ? "time-line__step--inactive" : ""
                  }`}
                >
                  <ReactSVG src={TravelStatusInTransit} />
                  <div className="time-line__step-state--in-transit">
                    {
                      t(BaseCardMessages.statusInTransitLabelText)
                    }
                  </div>
                  {travel?.plantDepartureTime ? (
                    <div className="time-line__step-time">
                      {utils.formatDateIfHave(
                        travel.plantDepartureTime,
                        "fullDateWithoutYearAndSeconds"
                      )}
                    </div>
                  ) : (
                    <div className="time-line__step-time"> &nbsp; &nbsp; </div>
                  )}
                  {travel?.plantDepartureTime ? (
                    <div className="time-line__step-time">
                      {" "}
                      {utils.formatDateIfHave(
                        intervalToDuration({
                          start: new Date(travel.plantDepartureTime),
                          end: travel.constructionStartTime
                            ? new Date(travel.constructionStartTime)
                            : new Date()
                        }),
                        "durationDescriptiveTime"
                      )}
                    </div>
                  ) : (
                    <div className="time-line__step-time"> &nbsp; &nbsp; </div>
                  )}
                </div>
              )}
            </Step>
            <Step transition="scale">
              {({ accomplished }) => (
                <div
                  className={`time-line__step ${
                    !accomplished ? "time-line__step--inactive" : ""
                  }`}
                >
                  <ReactSVG src={TravelStatusInConstruction} />
                  <div className="time-line__step-state--in-construction">
                    {
                      t(BaseCardMessages.statusInConstructionLabelText)
                    }
                  </div>
                  {travel?.constructionStartTime ? (
                    <div className="time-line__step-time">
                      {utils.formatDateIfHave(
                        travel.constructionStartTime,
                        "fullDateWithoutYearAndSeconds"
                      )}
                    </div>
                  ) : (
                    <div className="time-line__step-time"> &nbsp; &nbsp; </div>
                  )}
                  {travel?.constructionStartTime ? (
                    <div className="time-line__step-time">
                      {" "}
                      {utils.formatDateIfHave(
                        intervalToDuration({
                          start: new Date(travel.constructionStartTime),
                          end: travel.constructionEndTime
                            ? new Date(travel.constructionEndTime)
                            : new Date()
                        }),
                        "durationDescriptiveTime"
                      )}
                    </div>
                  ) : (
                    <div className="time-line__step-time"> &nbsp; &nbsp; </div>
                  )}
                </div>
              )}
            </Step>
            <Step transition="scale">
              {({ accomplished }) => (
                <div
                  className={`time-line__step ${
                    !accomplished ? "time-line__step--inactive" : ""
                  }`}
                >
                  <ReactSVG src={TravelStatusDischarging} />
                  <div className="time-line__step-state--discharging">
                    {
                      t(BaseCardMessages.statusDischargingLabelText)
                    }
                  </div>
                  {travel?.dischargeStartTime ? (
                    <div className="time-line__step-time">
                      {utils.formatDateIfHave(
                        travel.dischargeStartTime,
                        "fullDateWithoutYearAndSeconds"
                      )}
                    </div>
                  ) : (
                    <div className="time-line__step-time"> &nbsp; &nbsp; </div>
                  )}
                  {travel?.dischargeStartTime ? (
                    <div className="time-line__step-time">
                      {" "}
                      {utils.formatDateIfHave(
                        intervalToDuration({
                          start: new Date(travel.dischargeStartTime),
                          end: travel.dischargeEndTime
                            ? new Date(travel.dischargeEndTime)
                            : new Date()
                        }),
                        "durationDescriptiveTime"
                      )}
                    </div>
                  ) : (
                    <div className="time-line__step-time"> &nbsp; &nbsp; </div>
                  )}
                  {!travel?.dischargeStartTime
                      && travel.status === "DELIVERED" && (
                        <div className="time-line__step-time">Finalizando</div>
                  )}
                </div>
              )}
            </Step>
          </ProgressBar>
        </div>
      </div>
    </Styled.TimelineContainer>
  );
};

export default TravelTimeline;